import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './GlobalFAB.css';

const GlobalFAB = () => {
    const location = useLocation();

    // Don't show on post-ad page itself
    if (location.pathname === '/post-ad') return null;

    return (
        <Link
            to="/post-ad"
            className="global-fab"
            title="Post a New Ad"
        >
            <i className="fa-solid fa-plus"></i>
            <span className="fab-label">Post Ad</span>
        </Link>
    );
};

export default GlobalFAB;
